import { render, staticRenderFns } from "./event-image.vue?vue&type=template&id=187c6da6&"
import script from "./event-image.vue?vue&type=script&lang=js&"
export * from "./event-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports